import "../values.css";

export default function Values() {
  return (
    <div className="values-container">
      
      {/* 3. CORE VALUES ROW (Dark Navy Row) */}
      <section className="dlc-values-section">
        <div className="inner-max-width values-row-layout">
          
          {/* Left Side Header Block */}
          <div className="values-sidebar-header">
            <span className="section-mini-tag">Our Values</span>
            <h2 className="section-main-title">
              The Principles That<br />Guide Everything <span className="text-gold">We Do</span>
            </h2>
            <div className="accent-gold-line"></div>
          </div>

          {/* Right Side Content Grid */}
          <div className="values-horizontal-grid">
            
            <div className="value-inline-card">
              <div className="icon-circle-badge">💡</div>
              <div className="value-card-body">
                <h3>Innovation</h3>
                <p>Embracing cutting-edge design and construction technologies to deliver modern, efficient homes.</p>
              </div>
            </div>

            <div className="value-inline-card">
              <div className="icon-circle-badge">🏅</div>
              <div className="value-card-body">
                <h3>Quality</h3>
                <p>Uncompromising commitment to superior materials, craftsmanship, and attention to detail.</p>
              </div>
            </div>

            <div className="value-inline-card">
              <div className="icon-circle-badge">🛡️</div>
              <div className="value-card-body">
                <h3>Integrity</h3>
                <p>Building trust through transparency, honest communication, and ethical business practices.</p>
              </div>
            </div>

            <div className="value-inline-card">
              <div className="icon-circle-badge">🎯</div>
              <div className="value-card-body">
                <h3>Excellence</h3>
                <p>Striving to exceed expectations in every project, from concept to completion.</p>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* 4. WHY CHOOSE DLC ROW (Full-width Split Banner) */}
      <section className="dlc-why-banner">
        
        {/* Title Block */}
        <div className="why-banner-col title-block-col">
          <h2>Why Choose DLC?</h2>
          <p className="banner-sub-caps">Experience. Integrity. Results.</p>
        </div>

        {/* Experience Block */}
        <div className="why-banner-col list-block-col">
          <div className="banner-icon-badge">👥</div>
          <div>
            <h3>Experience & Expertise</h3>
            <ul className="banner-checklist">
              <li><span className="chk-icon">✔</span> Over 15 years in custom home building</li>
              <li><span className="chk-icon">✔</span> Licensed and insured professionals</li>
              <li><span className="chk-icon">✔</span> Award-winning designs and craftsmanship</li>
            </ul>
          </div>
        </div>

        {/* Promise Block + Right Overlay Image Background */}
        <div className="why-banner-col list-block-col graphic-bg-col">
          <div className="banner-icon-badge z-index-fix">🛡️</div>
          <div className="z-index-fix">
            <h3>Our Promise</h3>
            <ul className="banner-checklist">
              <li><span className="chk-icon">✔</span> Transparent pricing with no hidden costs</li>
              <li><span className="chk-icon">✔</span> On-time project completion</li>
              <li><span className="chk-icon">✔</span> Comprehensive warranty coverage</li>
            </ul>
          </div>
        </div>

      </section>
      
    </div>
  );
}